/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 16.11.17.
 */

import React from "react";
import PropTypes from "prop-types";
import update from "immutability-helper";

import ModalWizard from "../components/Bootstrap/ModalWizard";
import {PageActionActions, SubmitAction, GotoBackAction} from "../services/PageAction";

class ActionWizard extends React.Component {
    static propTypes = {
        steps: PropTypes.arrayOf(PropTypes.shape({
            /**
             * Called as:
             *  <Component {...props} onParamChange={onParamChangeCallback} params={params} prevParams={prevParams} />
             *  Where:
             *      onParamChangeCallback(paramName, newParamValue) - if step state is changed
             *      onParamChangeCallback("goto", "forward") - if forward navigation is desired
             *      onParamChangeCallback("goto", "back") - if back navigation is desirec
             */
            component: PropTypes.any.isRequired,
            title: PropTypes.any.isRequired,
            forwardButton: PropTypes.string,
            backButton: PropTypes.string,
            /**
             * Additional properties assigned to the component
             */
            props: PropTypes.object
        })).isRequired,
        /**
         * onClose(finished)
         */
        onClose: PropTypes.func,
        /**
         * If true then only forward button on last step will close the wizard
         */
        allowClose: PropTypes.bool,
    };

    static defaultProps = {};

    constructor(props) {
        super(props);
        let params = new Array(props.steps.length);
        params.fill({
            hideForward: false,
            hideBack: false,
            disableForward: false,
            disableBack: false,
            /**
             * Custom props used internally in wizard
             */
            componentProps: {}
        });

        this.state = {
            params: params,
            currentStep: 0
        };
        this.onClose = this.onClose.bind(this);
        this.onClickForward = this.onClickForward.bind(this);
        this.onClickBack = this.onClickBack.bind(this);
        this.onParamChange = this.onParamChange.bind(this);
    }


    onClose() {
        if (this.props.onClose) this.props.onClose(false);
    }

    onClickForward() {
        PageActionActions.callAction(new SubmitAction());
    }

    onClickBack() {
        PageActionActions.callAction(new GotoBackAction());
    }

    onParamChange(paramName, paramValue) {
        if (paramName === "goto") {
            switch (paramValue) {
                case "forward":
                    if (this.state.currentStep < this.props.steps.length-1) this.setState({currentStep: this.state.currentStep+1});
                    else if (this.props.onClose) this.props.onClose(true);
                    break;
                case "back":
                    if (this.state.currentStep > 0) this.setState({currentStep: this.state.currentStep-1});
                    break;
            }
        } else {
            let newParams = update(this.state.params, {[this.state.currentStep]: {[paramName]: {$set: paramValue}}});
            this.setState({params: newParams});
        }
    }

    render() {
        if (!this.props.steps || this.props.steps.length == 0) return null;

        let step = this.props.steps[this.state.currentStep];
        let Component = step.component;
        let params = this.state.params[this.state.currentStep];
        return (
            <ModalWizard
                title={step.title}
                forwardButton={params.hideForward ? null : step.forwardButton}
                backButton={params.hideBack ? null : step.backButton}
                forwardDisabled={params.disableForward}
                backDisabled={params.disableBack}
                onClose={this.props.allowClose ? this.onClose : null}
                onClickForward={this.onClickForward}
                onClickBack={this.onClickBack}
            >
                <Component {...step.props} onParamChange={this.onParamChange} params={params} prevParams={this.state.currentStep > 0 ? this.state.params[this.state.currentStep-1] : null} />
            </ModalWizard>
        );
    }
}

export default ActionWizard;
